import styled from '@emotion/styled';

const MDXStyledH3 = styled.h3`
  margin: 1rem 0 3px;
  font-size: 1.25rem;
  font-weight: 600;
`;

export default MDXStyledH3;
